import { useContext } from 'react';

import { MobXProviderContext } from 'mobx-react';

import { Stores } from 'mobx/stores';

export const useStores = (): Stores => useContext(MobXProviderContext) as Stores;
